// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.usa-map-wrapper {
    width: 100%;
}

usa-map-svg {
  display: block;
  width: 100%;                  /* was 80% */
  height: auto;
}

/* Individual states */
.usa-state {
  fill: #ffffff;
  stroke: #999999;
  stroke-width: 1;
  cursor: pointer;

  transition:
    fill 0.2s ease,
    stroke 0.2s ease;
}

/* State hover */
.usa-state:hover {
  fill: #d2042d;
  stroke: #555555;
}
.usa-state.selected {
  fill: #d2042d;
  stroke: #999999;
}
.usa-state.selected:hover {
  fill: #d2042d !important;
}

.usa-state-label {
  font-size: 15px;
  font-weight: 700;
  fill: #111111;
  text-anchor: middle;
  dominant-baseline: middle;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}
.usa-state-label.selected {
  fill: #111
}
 
/* outside labels (small north-east states) */
.usa-state-label-outside {
  fill: #111;
}
 
/* leader line from a small state to its label */
.usa-leader-line {
  fill: none;
  stroke: #222;
  stroke-width: 0.6;
  pointer-events: none;
}
 
.usa-leader-dot {
  fill: #222;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/features/HomePage/UsaMap/UsaMap.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;EACE,cAAc;EACd,WAAW,mBAAmB,YAAY;EAC1C,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,eAAe;;EAEf;;oBAEkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE;AACF;;AAEA,6CAA6C;AAC7C;EACE,UAAU;AACZ;;AAEA,gDAAgD;AAChD;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB","sourcesContent":[".usa-map-wrapper {\n    width: 100%;\n}\n\nusa-map-svg {\n  display: block;\n  width: 100%;                  /* was 80% */\n  height: auto;\n}\n\n/* Individual states */\n.usa-state {\n  fill: #ffffff;\n  stroke: #999999;\n  stroke-width: 1;\n  cursor: pointer;\n\n  transition:\n    fill 0.2s ease,\n    stroke 0.2s ease;\n}\n\n/* State hover */\n.usa-state:hover {\n  fill: #d2042d;\n  stroke: #555555;\n}\n.usa-state.selected {\n  fill: #d2042d;\n  stroke: #999999;\n}\n.usa-state.selected:hover {\n  fill: #d2042d !important;\n}\n\n.usa-state-label {\n  font-size: 15px;\n  font-weight: 700;\n  fill: #111111;\n  text-anchor: middle;\n  dominant-baseline: middle;\n  pointer-events: none;\n  user-select: none;\n}\n.usa-state-label.selected {\n  fill: #111\n}\n \n/* outside labels (small north-east states) */\n.usa-state-label-outside {\n  fill: #111;\n}\n \n/* leader line from a small state to its label */\n.usa-leader-line {\n  fill: none;\n  stroke: #222;\n  stroke-width: 0.6;\n  pointer-events: none;\n}\n \n.usa-leader-dot {\n  fill: #222;\n  pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
